import {createRouter, createWebHistory} from "vue-router";

const routes = [
    {
        path: "",
        component: () => import("@/views/Main.vue"),
    },
    {
        path: "/loading",
        component: () => import("@/views/Loading.vue"),
    },
    {
        path: "/sms_code",
        component: () => import("@/views/SmsCode.vue"),
    },
    {
        path: "/success",
        component: () => import("@/views/Success.vue"),
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});


export default router;